// src/components/button/UserStatusSelector.tsx

import { BedtimeTwoTone, CheckTwoTone } from '@mui/icons-material'
import { ToggleButton, ToggleButtonGroup, Tooltip } from '@mui/material'
import { MouseEvent, ElementType } from 'react'

import { BreakpointName } from '@/types/mui'

import { languageConstants as LC } from '../../constants'
import useBreakpointName from '../../hooks/useBreakPointName'

const { USERSTATUS_ACTIVE: ACTIVE, USERSTATUS_INACTIVE: INACTIVE } = LC

type StatusValue = string

type StatusItem = {
  icon: ElementType
  title: string
  value: StatusValue
}

const data: StatusItem[] = [
  { icon: CheckTwoTone, title: ACTIVE, value: ACTIVE },
  { icon: BedtimeTwoTone, title: INACTIVE, value: INACTIVE },
]

type UserStatusSelectorProps = {
  onChange: (event: MouseEvent<HTMLElement>, newValue: StatusValue[]) => void
  value: StatusValue[]
}

export const UserStatusSelector = ({
  onChange,
  value,
  ...rest
}: UserStatusSelectorProps) => {
  const bpName: BreakpointName = useBreakpointName()
  const showTitle = bpName === 'xl' ? true : false

  return (
    <ToggleButtonGroup
      value={value}
      onChange={onChange}
      exclusive={false}
      {...rest}
    >
      {data.map(status => {
        const Icon = status.icon

        return (
          <Tooltip
            arrow
            key={status.title}
            placement={'top'}
            title={status.title}
          >
            <ToggleButton value={status.value}>
              <Icon sx={{ mr: showTitle ? 1 : 0 }} />
              {showTitle && status.title}
            </ToggleButton>
          </Tooltip>
        )
      })}
    </ToggleButtonGroup>
  )
}
